module.exports = __webpack_public_path__ + "static/media/bg_nextgen.437e2f0d.jpg";